
//JS version: https://git.autodesk.com/tandem/dt-server/blob/master/src/autodesk.com/double-trouble/geom/geom-hash/ghash_eigen.c
//See also: https://git.autodesk.com/fluent/otg/blob/master/src/geom/matrix-math.js

"use strict";


function Matrix(rows, cols) {
	this.rows = new Array(rows);
	for (var i=0; i<rows; i++) {
		var col = new Array(cols);
		this.rows[i] = col;
		for(var j=0; j<cols; j++)
			col[j] = 0;
	}
}

Matrix.prototype.swapRows = function(r0, r1) {
	var tmp = this.rows[r0];
	this.rows[r0] = this.rows[r1];
	this.rows[r1] = tmp;
	/*
	for (var i=0; i<this.cols; i++) {
		var tmp = this.rows[r0][i];
		this.rows[r0][i] = this.rows[r1][i];
		this.rows[r1][i] = tmp;
	}
	*/
};

Matrix.prototype.zero = function() {
	for (var i=0; i<this.rows.length; i++) {
		var r = this.rows[i];
		for (var j=0; j<r.length; j++)
			r[j] = 0;
	}
};

Matrix.prototype.toThree = function(mtx) {

	var e = mtx.elements;
	var rows = this.rows;

	e[0] = rows[0][0];
	e[1] = rows[1][0];
	e[2] = rows[2][0];
	e[3] = rows.length > 3 ? rows[3][0] : 0;

	e[4] = rows[0][1];
	e[5] = rows[1][1];
	e[6] = rows[2][1];
	e[7] = rows.length > 3 ? rows[3][1] : 0;

	e[8] = rows[0][2];
	e[9] = rows[1][2];
	e[10]= rows[2][2];
	e[11]= rows.length > 3 ? rows[3][2] : 0;

	if (rows[0].length > 3) {
		e[12] = rows[0][3];
		e[13] = rows[1][3];
		e[14] = rows[2][3];
		e[15] = rows.length > 3 ? rows[3][3] : 1;
	} else {
		e[12] = 0;
		e[13] = 0;
		e[14] = 0;
		e[15] = 1;
	}
};

//Allocate matrices used by the derive function once
//so we don't create them all the time
var DIM = 3;

// http://barnesc.blogspot.ca/2007/02/eigenvectors-of-3x3-symmetric-matrix.html
/* Eigen decomposition code for symmetric 3x3 matrices, copied from the public
   domain Java Matrix library JAMA. */

var MAX = Math.max;
var fabs = Math.abs;
var pow = Math.pow;

function hypot2(x, y) {
  return Math.sqrt(x*x+y*y);
}

//Temporary variable used by tred2 and tql2
var e = new Array(DIM);

// Symmetric Householder reduction to tridiagonal form.

function tred2(V/*[DIM][DIM]*/, d/*[DIM]*/, e/*[DIM]*/) {

//  This is derived from the Algol procedures tred2 by
//  Bowdler, Martin, Reinsch, and Wilkinson, Handbook for
//  Auto. Comp., Vol.ii-Linear Algebra, and the corresponding
//  Fortran subroutine in EISPACK.

  for (let j = 0; j < DIM; j++) {
    d[j] = V[DIM-1][j];
  }

  // Householder reduction to tridiagonal form.

  for (let i = DIM-1; i > 0; i--) {

    // Scale to avoid under/overflow.

    let scale = 0.0;
    let h = 0.0;
    for (let k = 0; k < i; k++) {
      scale = scale + fabs(d[k]);
    }
    if (scale == 0.0) {
      e[i] = d[i-1];
      for (let j = 0; j < i; j++) {
        d[j] = V[i-1][j];
        V[i][j] = 0.0;
        V[j][i] = 0.0;
      }
    } else {

      // Generate Householder vector.

      for (let k = 0; k < i; k++) {
        d[k] /= scale;
        h += d[k] * d[k];
      }
      let f = d[i-1];
      let g = Math.sqrt(h);
      if (f > 0) {
        g = -g;
      }
      e[i] = scale * g;
      h = h - f * g;
      d[i-1] = f - g;
      for (let j = 0; j < i; j++) {
        e[j] = 0.0;
      }

      // Apply similarity transformation to remaining columns.

      for (let j = 0; j < i; j++) {
        f = d[j];
        V[j][i] = f;
        g = e[j] + V[j][j] * f;
        for (let k = j+1; k <= i-1; k++) {
          g += V[k][j] * d[k];
          e[k] += V[k][j] * f;
        }
        e[j] = g;
      }
      f = 0.0;
      for (let j = 0; j < i; j++) {
        e[j] /= h;
        f += e[j] * d[j];
      }
      let hh = f / (h + h);
      for (let j = 0; j < i; j++) {
        e[j] -= hh * d[j];
      }
      for (let j = 0; j < i; j++) {
        f = d[j];
        g = e[j];
        for (let k = j; k <= i-1; k++) {
          V[k][j] -= (f * e[k] + g * d[k]);
        }
        d[j] = V[i-1][j];
        V[i][j] = 0.0;
      }
    }
    d[i] = h;
  }

  // Accumulate transformations.

  for (let i = 0; i < DIM-1; i++) {
    V[DIM-1][i] = V[i][i];
    V[i][i] = 1.0;
    let h = d[i+1];
    if (h != 0.0) {
      for (let k = 0; k <= i; k++) {
        d[k] = V[k][i+1] / h;
      }
      for (let j = 0; j <= i; j++) {
        let g = 0.0;
        for (let k = 0; k <= i; k++) {
          g += V[k][i+1] * V[k][j];
        }
        for (let k = 0; k <= i; k++) {
          V[k][j] -= g * d[k];
        }
      }
    }
    for (let k = 0; k <= i; k++) {
      V[k][i+1] = 0.0;
    }
  }
  for (let j = 0; j < DIM; j++) {
    d[j] = V[DIM-1][j];
    V[DIM-1][j] = 0.0;
  }
  V[DIM-1][DIM-1] = 1.0;
  e[0] = 0.0;
}

// Symmetric tridiagonal QL algorithm.

function tql2(V/*[DIM][DIM]*/, d/*[DIM]*/, e/*[DIM]*/) {

//  This is derived from the Algol procedures tql2, by
//  Bowdler, Martin, Reinsch, and Wilkinson, Handbook for
//  Auto. Comp., Vol.ii-Linear Algebra, and the corresponding
//  Fortran subroutine in EISPACK.

  for (let i = 1; i < DIM; i++) {
    e[i-1] = e[i];
  }
  e[DIM-1] = 0.0;

  let f = 0.0;
  let tst1 = 0.0;
  let eps = pow(2.0,-52.0);
  for (let l = 0; l < DIM; l++) {

    // Find small subdiagonal element

    tst1 = MAX(tst1,fabs(d[l]) + fabs(e[l]));
    let m = l;
    while (m < DIM) {
      if (fabs(e[m]) <= eps*tst1) {
        break;
      }
      m++;
    }

    // If m == l, d[l] is an eigenvalue,
    // otherwise, iterate.

    if (m > l) {
      let iter = 0;
      do {
        iter = iter + 1;  // (Could check iteration count here.)

        // Compute implicit shift

        let g = d[l];
        let p = (d[l+1] - g) / (2.0 * e[l]);
        let r = hypot2(p,1.0);
        if (p < 0) {
          r = -r;
        }
        d[l] = e[l] / (p + r);
        d[l+1] = e[l] * (p + r);
        let dl1 = d[l+1];
        let h = g - d[l];
        for (let i = l+2; i < DIM; i++) {
          d[i] -= h;
        }
        f = f + h;

        // Implicit QL transformation.

        p = d[m];
        var c = 1.0;
        var c2 = c;
        var c3 = c;
        var el1 = e[l+1];
        var s = 0.0;
        var s2 = 0.0;
        for (let i = m-1; i >= l; i--) {
          c3 = c2;
          c2 = c;
          s2 = s;
          g = c * e[i];
          h = c * p;
          r = hypot2(p,e[i]);
          e[i+1] = s * r;
          s = e[i] / r;
          c = p / r;
          p = c * d[i] - s * g;
          d[i+1] = h + s * (c * g + s * d[i]);

          // Accumulate transformation.

          for (let k = 0; k < DIM; k++) {
            h = V[k][i+1];
            V[k][i+1] = s * V[k][i] + c * h;
            V[k][i] = c * V[k][i] - s * h;
          }
        }
        p = -s * s2 * c3 * el1 * e[l] / dl1;
        e[l] = s * p;
        d[l] = c * p;

        // Check for convergence.

      } while (fabs(e[l]) > eps*tst1);
    }
    d[l] = d[l] + f;
    e[l] = 0.0;
  }
}

//Was originally inline at the end of tql2, moved out to reuse
function sort_vals(V, d) {
  // Sort eigenvalues and corresponding vectors.
  for (let i = 0; i < DIM-1; i++) {
    let k = i;
    let p = d[i];
    for (let j = i+1; j < DIM; j++) {
      if (d[j] < p) {
        k = j;
        p = d[j];
      }
    }
    if (k != i) {
      d[k] = d[i];
      d[i] = p;
      for (let j = 0; j < DIM; j++) {
        p = V[j][i];
        V[j][i] = V[j][k];
        V[j][k] = p;
      }
    }
  }
}


/* Symmetric matrix A => eigenvectors in columns of V, corresponding
   eigenvalues in d. */
function eigen_decomposition(A/*[DIM][DIM]*/, V/*[DIM][DIM]*/, d/*[DIM]*/) {
  for (let i = 0; i < DIM; i++) {
    for (let j = 0; j < DIM; j++) {
		V.rows[i][j] = A.rows[i][j];
    }
  }
  tred2(V.rows, d, e);
  tql2(V.rows, d, e);
  //sort_vals(V.rows, d);
}

/*
let numeric = require('numeric');

function eigen_decomposition_debug(A, V, d) {

  eigen_decomposition(A, V, d);

  let test = numeric.eig(A.rows);
  sort_vals(test.E.x, test.lambda.x);

  for (let i=0; i<3; i++) {
    for (let j=0; j<3; j++) {
      if (Math.abs(test.E.x[i][j] - V.rows[i][j]) > 1e-5)
        console.log("Possibly incorrect eigen decomposition");
    }
  }
}
*/

module.exports = {
	Matrix: Matrix,
	eigen_decomposition: eigen_decomposition,
	sort_vals: sort_vals
};
